var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 112 150",
    style: {
      enableBackground: "new 0 0 112 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.43,43.14c-8.55,8.55-8.55,22.42,0,30.97c8.55,8.55,22.42,8.55,30.97,0c8.55-8.55,8.55-22.42,0-30.97 C59.85,34.59,45.98,34.59,37.43,43.14z M56.1,55.44h11.29l0,6.37l-11.28,0l0,11.28h-6.37l0-11.29l-11.28,0l0-6.37h11.28l0-11.28 l6.37,0L56.1,55.44z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.53,32.19H86.57c-1.81,0-3.29-1.72-3.29-3.83v-9.86c0-6.95-5.4-12.59-12.05-12.59H16.48 c-6.65,0-12.05,5.65-12.05,12.59V133.5c0,6.95,5.4,12.6,12.05,12.6h81.05c6.65,0,12.05-5.65,12.05-12.6V44.78 C109.57,37.83,104.17,32.19,97.53,32.19z M100.81,133.5c0,2.11-1.48,3.83-3.29,3.83H16.48c-1.81,0-3.29-1.72-3.29-3.83V18.49 c0-2.11,1.48-3.83,3.29-3.83h54.77c1.81,0,3.28,1.72,3.28,3.83v9.86c0,6.95,5.4,12.59,12.05,12.59h10.95 c1.81,0,3.29,1.72,3.29,3.83V133.5z M87.67,93.52H26.33c-2.42,0-4.38,1.96-4.38,4.38c0,2.42,1.96,4.38,4.38,4.38h61.34 c2.42,0,4.38-1.96,4.38-4.38C92.05,95.49,90.09,93.52,87.67,93.52z M87.67,111.05H26.33c-2.42,0-4.38,1.96-4.38,4.38 c0,2.42,1.96,4.38,4.38,4.38h61.34c2.42,0,4.38-1.96,4.38-4.38C92.05,113.01,90.09,111.05,87.67,111.05z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCourse);
export default __webpack_public_path__ + "static/media/newCourse.f4bb9d69f3cfd25244a8476f3908a11c.svg";
export { ForwardRef as ReactComponent };